<template>
    <MonitorDataBase :selectedLoops="selectedLoops" :real-data="realData" :options="options" :current-loop="currentLoop">
       
    </MonitorDataBase>
    
</template>

<script>
    import Curve from "../../chart/Curve";
    import MonitorDataBase from "./MonitorDataBase";

    export default {
        name: "PowerData",
        components: {
            Curve,
            MonitorDataBase
        },
        props: {
            currentLoop: Object,
            selectedLoops: Array
        },
        computed: {
            options() {
                if (this.routeName === 'Inverter') {
                    return [{
                            value: '1-2',
                            label: '发电量'
                        },
                        {
                            value: '0-1',
                            label: '效率'
                        },
                        {
                            value: '0-2',
                            label: '功率'
                        },
                        {
                            value: '0-3',
                            label: '电压'
                        },
                        {
                            value: '1-0',
                            label: '电流'
                        },
                        {
                            value: '1-1',
                            label: '电网频率'
                        }
                    ]
                }
                if (this.routeName === 'EnergyStorage') {
                    return [{
                            value: '0-0',
                            label: '直流侧三相线电压'
                        },{
                            value: '0-2',
                            label: '直流侧三相线电压'
                        },{
                            value: '0-1',
                            label: '输出侧三相线电压'
                        },
                        {
                            value: '1-2',
                            label: '输出侧三相线电压'
                        },
                        {
                            value: '1-3',
                            label: '输出侧三相线电压'
                        },
                        {
                            value: '1-4',
                            label: '输出侧三相线电压'
                        }
                    ]
                }
                if (this.routeName === 'Battery') {
                    if(this.currentLoop.status === 'group'){
                        return [{
                                value: '剩余电量',
                                label: '剩余电量'
                            },
                            {
                                value: '0-1',
                                label: '健康度'
                            },
                            {
                                value: '0-2',
                                label: '单体电压'
                            },
                            {
                                value: '0-3',
                                label: '温度'
                            }
                        ]
                    }
                    return [{
                            value: '剩余电量',
                            label: '剩余电量'
                        },
                        {
                            value: '0-1',
                            label: '健康度'
                        },
                        {
                            value: '0-2',
                            label: '充电量'
                        },
                        {
                            value: '0-3',
                            label: '放电量'
                        },
                        {
                            value: '1-0',
                            label: '电压'
                        },
                        {
                            value: '1-1',
                            label: '电流'
                        }
                    ]
                }
             
                    return [{
                            value: '0-0',
                            label: '功率因数'
                        },
                        {
                            value: '0-1',
                            label: '有功功率'
                        },
                        {
                            value: '0-2',
                            label: '无功功率'
                        },
                        {
                            value: '0-3',
                            label: '视在功率'
                        },
                        {
                            value: '1-0',
                            label: '三相电压'
                        },
                        {
                            value: '1-1',
                            label: '三相线电压'
                        },
                        {
                            value: '1-2',
                            label: '三相电流'
                        },
                        {
                            value: '2-0',
                            label: '母排温度'
                        },
                    ]
             

            },
            tag() {
                return this.$route.params.tag
            },
            routeName() {
                return this.$route.params.name
            },
            realData() {

                if (this.routeName === 'Transformer') {
                    return [{},
                        {
                            type: "",
                            details: [{
                                    key: "三相温度",
                                    unit: "℃",
                                    data: {
                                        'A': "Temperature_A",
                                        'B': "Temperature_B",
                                        'C': "Temperature_C",
                                        '环境温度': "Temperature",
                                    }
                                },
                                {},
                                {
                                    key: "负载监测",
                                    unit: "VA",
                                    multiple: 0.001,
                                    data: {
                                        "负载监测": "P",
                                    },
                                },

                            ]
                        },
                    ]
                }
                if (this.routeName === 'Breaker') {
                    return [{
                            type: "功率",
                            details: [{
                                    key: "功率因数",
                                    unit: "",
                                    data: {
                                        A: "PFa",
                                        B: "PFb",
                                        C: "PFc",
                                        总: "PF",
                                    }
                                },
                                {
                                    key: "有功功率",
                                    unit: "kW",
                                    multiple: 0.001,
                                    data: {
                                        A: "PAa",
                                        B: "PAb",
                                        C: "PAc",
                                        总: "PA",
                                    }
                                },
                                {
                                    key: "无功功率",
                                    unit: "kVar",
                                    multiple: 0.001,
                                    data: {
                                        A: "PRa",
                                        B: "PRb",
                                        C: "PRc",
                                        总: "PR",
                                    },
                                },
                                {
                                    key: "视在功率",
                                    unit: "kVA",
                                    multiple: 0.001,
                                    data: {
                                        A: "Pa",
                                        B: "Pb",
                                        C: "Pc",
                                        总: "P",
                                    }
                                },

                            ]
                        },
                        {
                            type: "电压、电流",
                            details: [{
                                    key: "三相电压",
                                    unit: "V",
                                    data: {
                                        A: "Ua",
                                        B: "Ub",
                                        C: "Uc",
                                    }
                                },
                                {
                                    key: "三相线电压",
                                    unit: "V",
                                    data: {
                                        A: "Uab",
                                        B: "Ubc",
                                        C: "Uac",
                                    }
                                },
                                {
                                    key: "三相电流",
                                    unit: "A",
                                    data: {
                                        A: "Ia",
                                        B: "Ib",
                                        C: "Ic",
                                    }
                                },
                            ]
                        },
                        {
                            type: "触头温度",
                            details: [{
                                    key: "触头温度",
                                    unit: "℃",
                                    data: {
                                        A: "",
                                        B: "Temperature",
                                        C: "",
                                    }
                                }

                            ]
                        },

                    ]
                }

                if (this.routeName === 'PowerQuality') {
                    return [

                        {
                            type: "电压总谐波",
                            details: [{
                                    key: "",
                                    unit: "%",
                                    data: {
                                        "A": "THD_Ua",
                                        "B": "THD_Ub",
                                        "C": "THD_Uc",
                                    }
                                },

                            ]
                        },
                        {
                            type: "电流总谐波",
                            details: [{
                                    key: "",
                                    unit: "%",
                                    data: {
                                        "A": "THD_Ia",
                                        "B": "THD_Ib",
                                        "C": "THD_Ic",
                                    }
                                },

                            ]
                        },
                        // {
                        // 						type: "三相电压不平衡度",
                        // 						details: [
                        // 							{
                        // 								key: "",
                        // 								unit: "%",
                        // 								data: {
                        // 									"不平衡度": "U_unbl",
                        // 								}
                        // 							}
                        // 						]
                        // 					},
                        // 					{
                        // 						type: "三相电流不平衡度",
                        // 						details: [
                        // 							{
                        // 								key: "",
                        // 								unit: "%",
                        // 								data: {
                        // 									"不平衡度": "I_unbl",
                        // 								}
                        // 							},
                        // 						]
                        // 					},

                        ...this.createData()

                    ]
                }

                    if (this.currentLoop.uniaxial) {
                        return [{
                                type: "功率",
                                details: [{
                                        key: "功率因数",
                                        unit: "",
                                        data: {
                                            A: "PFa",
                                            B: "PFb",
                                            C: "PFc",
                                            总: "PF",
                                        }
                                    },
                                    {
                                        key: "有功功率",
                                        unit: "kW",
                                        // 这个属性，计算的时候会乘进去 0.001 就是除以1000
                                        //multiple: 0.001,
                                        multiple: 0.001,
                                        data: {
                                            A: "PAa",
                                            B: "PAb",
                                            C: "PAc",
                                            总: "PA",
                                        }
                                    },
                                    {
                                        key: "无功功率",
                                        unit: "kVar",
                                        multiple: 0.001,
                                        data: {
                                            A: "PRa",
                                            B: "PRb",
                                            C: "PRc",
                                            总: "PR",
                                        }
                                    },
                                    {
                                        key: "视在功率",
                                        unit: "kVA",
                                        multiple: 0.001,
                                        data: {
                                            A: "Pa",
                                            B: "Pb",
                                            C: "Pc",
                                            总: "P",
                                        }
                                    },

                                ]
                            },
                            {
                                type: "电压、电流",
                                details: [{
                                        key: "三相电压",
                                        unit: "V",
                                        data: {
                                            A: "Ua",
                                            B: "Ub",
                                            C: "Uc",
                                        }
                                    },
                                    {
                                        key: "三相线电压",
                                        unit: "V",
                                        data: {
                                            A: "Uab",
                                        B: "Ubc",
                                        C: "Uac",
                                        }
                                    },
                                    {
                                        key: "三相电流",
                                        unit: "A",
                                        data: {
                                            'A': "Ia",
                                            'B': "Ib",
                                            'C': "Ic",
                                        }
                                    },
                                ]
                            },
                            {
                                type: "温度",
                                details: [{
                                        key: "母排温度",
                                        unit: "℃",
                                        data: {
                                            A: "Temperature_A",
                                            B: "Temperature_B",
                                            C: "Temperature_C"
                                        }
                                    }

                                ]
                            },
                        ]
                    } else if (this.currentLoop.busbarTemperature == 1) {
                        return [{
                                type: "功率",
                                details: [{
                                        key: "功率因数",
                                        unit: "",
                                        data: {
                                            A: "PFa",
                                            B: "PFb",
                                            C: "PFc",
                                            总: "PF",
                                        }
                                    },
                                    {
                                        key: "有功功率",
                                        unit: "kW",
                                        // 这个属性，计算的时候会乘进去 0.001 就是除以1000
                                        //multiple: 0.001,
                                        multiple: 0.001,
                                        data: {
                                            A: "PAa",
                                            B: "PAb",
                                            C: "PAc",
                                            总: "PA",
                                        }
                                    },
                                    {
                                        key: "无功功率",
                                        unit: "kVar",
                                        multiple: 0.001,
                                        data: {
                                            A: "PRa",
                                            B: "PRb",
                                            C: "PRc",
                                            总: "PR",
                                        }
                                    },
                                    {
                                        key: "视在功率",
                                        unit: "kVA",
                                        multiple: 0.001,
                                        data: {
                                            A: "Pa",
                                            B: "Pb",
                                            C: "Pc",
                                            总: "P",
                                        }
                                    },

                                ]
                            },
                            {
                                type: "电压、电流",
                                details: [{
                                        key: "三相电压",
                                        unit: "V",
                                        data: {
                                            A: "Ua",
                                            B: "Ub",
                                            C: "Uc",
                                        }
                                    },
                                    {
                                        key: "三相线电压",
                                        unit: "V",
                                        data: {
                                            A: "Uab",
                                        B: "Ubc",
                                        C: "Uac",
                                        }
                                    },
                                    {
                                        key: "三相电流",
                                        unit: "A",
                                        data: {
                                            'A': "Ia",
                                            'B': "Ib",
                                            'C': "Ic",
                                        }
                                    },
                                ]
                            },
                            {
                                type: "温度",
                                details: [{
                                        key: "进线母排温度",
                                        unit: "℃",
                                        data: {
                                            A: "Temperature_in_A",
                                            B: "Temperature_in_B",
                                            C: "Temperature_in_C"
                                        }
                                    }, {
                                        key: "出线母排温度",
                                        unit: "℃",
                                        data: {
                                            A: "Temperature_out_A",
                                            B: "Temperature_out_B",
                                            C: "Temperature_out_C"
                                        }
                                    }

                                ]
                            },
                        ]
                    } else {

                        if (this.routeName === "protect1") {
                            return [{
                                    type: "功率",
                                    details: [{
                                            key: "功率因数",
                                            unit: "",
                                            data: {
                                                A: "PFa",
                                                B: "PFb",
                                                C: "PFc",
                                                总: "PF",
                                            }
                                        },
                                        {
                                            key: "有功功率",
                                            unit: "kW",
                                            // 这个属性，计算的时候会乘进去 0.001 就是除以1000
                                            //multiple: 0.001,
                                            multiple: 0.001,
                                            data: {
                                                A: "PAa",
                                                B: "PAb",
                                                C: "PAc",
                                                总: "PA",
                                            }
                                        },
                                        {
                                            key: "无功功率",
                                            unit: "kVar",
                                            multiple: 0.001,
                                            data: {
                                                A: "PRa",
                                                B: "PRb",
                                                C: "PRc",
                                                总: "PR",
                                            }
                                        },
                                        {
                                            key: "视在功率",
                                            unit: "kVA",
                                            multiple: 0.001,
                                            data: {
                                                A: "Pa",
                                                B: "Pb",
                                                C: "Pc",
                                                总: "P",
                                            }
                                        },

                                    ]
                                },
                                {
                                    type: "电压、电流",
                                    details: [{
                                            key: "三相电压",
                                            unit: "V",
                                            data: {
                                                A: "Ua",
                                                B: "Ub",
                                                C: "Uc",
                                            }
                                        },
                                        {
                                            key: "三相线电压",
                                            unit: "V",
                                            data: {
                                                A: "Uab",
                                        B: "Ubc",
                                        C: "Uac",
                                            }
                                        },
                                        {
                                            key: "三相电流",
                                            unit: "A",
                                            data: {
                                                A: "I1a",
                                                B: "I1b",
                                                C: "I1c",
                                            }
                                        },
                                    ]
                                },

                            ]
                        } else {
                            return [{
                                    type: "功率",
                                    details: [{
                                            key: "功率因数",
                                            unit: "",
                                            data: {
                                                A: "PFa",
                                                B: "PFb",
                                                C: "PFc",
                                                总: "PF",
                                            }
                                        },
                                        {
                                            key: "有功功率",
                                            unit: "kW",
                                            // 这个属性，计算的时候会乘进去 0.001 就是除以1000
                                            //multiple: 0.001,
                                            multiple: 0.001,
                                            data: {
                                                A: "PAa",
                                                B: "PAb",
                                                C: "PAc",
                                                总: "PA",
                                            }
                                        },
                                        {
                                            key: "无功功率",
                                            unit: "kVar",
                                            multiple: 0.001,
                                            data: {
                                                A: "PRa",
                                                B: "PRb",
                                                C: "PRc",
                                                总: "PR",
                                            }
                                        },
                                        {
                                            key: "视在功率",
                                            unit: "kVA",
                                            multiple: 0.001,
                                            data: {
                                                A: "Pa",
                                                B: "Pb",
                                                C: "Pc",
                                                总: "P",
                                            }
                                        },

                                    ]
                                },
                                {
                                    type: "电压、电流",
                                    details: [{
                                            key: "三相电压",
                                            unit: "V",
                                            data: {
                                                A: "Ua",
                                                B: "Ub",
                                                C: "Uc",
                                            }
                                        },
                                        {
                                            key: "三相线电压",
                                            unit: "V",
                                            data: {
                                                A: "Uab",
                                                B: "Ubc",
                                                C: "Uac",
                                            }
                                        },


                                        //                    if(this.routeName === 'protect1'){
                                        //   return [

                                        //         {
                                        //             type: "电流",
                                        //             details: [{
                                        //                     key: "",
                                        //                     unit: "%",
                                        //                     data: {
                                        //                         "A": "I1a",
                                        //                         "B": "I1b",
                                        //                         "C": "I1c",
                                        //                     }
                                        //                 },

                                        //             ]
                                        //         },
                                        //   ]
                                        //   }
                                        {
                                            key: "三相电流",
                                            unit: "A",
                                            data: {
                                                'A': "Ia",
                                                'B': "Ib",
                                                'C': "Ic",
                                            }
                                        },
                                    ]
                                },
                                {
                                    type: "温度",
                                    details: [{
                                            key: "母排温度",
                                            unit: "℃",
                                            data: {
                                                A: "Temperature_A",
                                                B: "Temperature_B",
                                                C: "Temperature_C"
                                            }
                                        }

                                    ]
                                },
                            ]
                        }
                    }
             
            }
        },
        data() {
            return {
                node: "",

                date: new Date(),
                diagramSelected: 0,

            }
        },
        methods: {
            createData() {
                let res = []
                if (this.$store.state.project.currentProject.projectId == 4) {
                    for (let i = 2; i <= 31; i++) {
                        res.push({
                            type: `电压${i}次谐波`,
                            details: [{
                                    key: "",
                                    unit: "%",
                                    data: {
                                        "A": `H_Ua_${i}`,
                                        "B": `H_Ub_${i}`,
                                        "C": `H_Uc_${i}`,
                                    }
                                },

                            ]
                        }, {
                            type: `电流${i}次谐波`,
                            details: [{
                                key: "",
                                unit: "%",
                                data: {
                                    "A": `H_Ia_${i}`,
                                    "B": `H_Ib_${i}`,
                                    "C": `H_Ic_${i}`,
                                }
                            }, ]
                        }, )
                    }
                } else {
                    for (let i = 2; i <= 31; i++) {
                        res.push({
                            type: `电压${i}次谐波`,
                            details: [{
                                    key: "",
                                    unit: "%",
                                    data: {
                                        "A": `HUa${i}`,
                                        "B": `HUb${i}`,
                                        "C": `HUc${i}`,
                                    }
                                },

                            ]
                        }, {
                            type: `电流${i}次谐波`,
                            details: [{
                                key: "",
                                unit: "%",
                                data: {
                                    "A": `HIa${i}`,
                                    "B": `HIb${i}`,
                                    "C": `HIc${i}`,
                                }
                            }, ]
                        }, )
                    }
                }

                return res
            }
        }
    }
</script>

<style scoped lang="less">
    .transformer {
        width: 100%;
        height: 100%;

        span {
            font-size: 18rem;
            font-weight: bold;
        }

        >div {
            margin-right: 72rem;
        }

        .k {
            color: #333333;
            margin-right: 18rem;
        }

        .v {
            color: #0D94FF;
        }
    }

    .breaker {
        width: 100%;
        height: 100%;
        // background-color: rgba(0, 43, 102, 0.04);
        padding-left: 8rem;

        span {
            font-size: 18rem;
            font-weight: bold;
        }

        .k {
            color: #333333;
            margin-right: 24rem;
        }

        .v {
            color: red;
            ;
        }

        .Handcart {
            color: #0D94FF;
        }

        .sate {
            padding-left: 325rem;
        }
    }
</style>